import { CommonInfoService } from './../cart-process/common-info.service';
import { Component } from '@angular/core';
import { LogoutModalService } from '../services/logoutModalService';
import {
  NotificationProviderService,
  NotificationProviderTypeEnum
} from '../external-interfaces/notification-provider.service';
import { CartClearConfirmationService } from '../services/cart-clear-confirmation.service';
import CustomerDetailsService from '../cart-process/customer-details.service';
import { CustomerDetailsModel } from '../models/customer-details.model';

@Component({
  selector: 'headline-component',
  templateUrl: './headline.component.html',
  providers: [
    LogoutModalService
  ]
})
export class HeadlineComponent {
  public customerDataName: string;
  public isVirginBrand: boolean;

  constructor(
    public customerDetailsService: CustomerDetailsService,
    private logoutModalService: LogoutModalService,
    private notificationProvider: NotificationProviderService,
    private cartClearConfirmationService: CartClearConfirmationService,
    private commonInfo: CommonInfoService
  ) {
    this.notificationProvider.subscribe(
      NotificationProviderTypeEnum.CUSTOMER_DETAILS,
      (customerData: CustomerDetailsModel) => {
        if (customerData) {
          this.customerDataName = customerData.firstName ? customerData.firstName : '';
        }
      });
    this.isVirginBrand = this.commonInfo.isVirginBrand;
  }

  public cartClearConfirmationModal(event: Event): void {
    event.preventDefault();

    this.cartClearConfirmationService.cartClear();
  }

  public showLogoutModal(event: Event): void {
    event.preventDefault();

    this.logoutModalService.showModal();
  }
}
